export const data = [
  {
    id: 1,
    step: "step 1",
    title: "your info",
  },
  {
    id: 2,
    step: "step 2",
    title: "Signature",
  },
  {
    id: 3,
    step: "step 3",
    title: "add-ons",
  },
  {
    id: 4,
    step: "step 4",
    title: "summary",
  },
];
